<div>
  <div class="row">
    <div class="col">
      <h3>Contractor Types</h3>
    </div>
    <div class="col" *ngIf="canAddContractorType || isGlobalAdmin">
      <div class="d-flex justify-content-end align-items-center">
        <button
          *ngIf="isGlobalAdmin"
          type="button"
          class="btn btn-raised btn-default mr-2"
          (click)="openImportDialog()"
          title="Import a contractor type from another environment"
        >
          Import Contractor Type
        </button>
        <button
          *ngIf="canAddContractorType"
          type="button"
          class="btn btn-raised btn-success"
          (click)="createContractorType()"
        >
          New Contractor Type
        </button>
      </div>
    </div>
  </div>

  <!-- Hidden file input for importing -->
  <input
    #importFileInput
    type="file"
    accept=".json"
    hidden
    (change)="onImportFileSelected($event)"
  />

  <wm-contractor-type-list
    #contractorTypeList
    [contractorTypes]="contractorTypes"
    (onPublish)="publishContractorType($event.contractorTypeId, $event.reason)"
    (onDelete)="deletedContractorType($event)"
    (onCopy)="startTypeCopy($event)"
    (onHistory)="showHistory($event)"
  >
  </wm-contractor-type-list>

  <wm-modal-confirm
    title="Copy Contractor Type"
    moduleId="copy-contractor-type"
    [showButtonText]="true"
    [enabled]="true"
    [showButton]="false"
    [closeOnAccept]="false"
    commandText="Copy"
    [form]="targetForm"
    (accepted)="copyType(copyTypeId)"
    #copyTypeModal
  >
    <form [formGroup]="targetForm">
      <label for="targetClientId" class="bmd-label-static">
        Jurisdiction
      </label>
      <select
        class="form-control"
        [(ngModel)]="targetClientId"
        name="targetClientId"
        formControlName="targetClientId"
        *ngIf="(clients || []).length > 1"
      >
        <option *ngFor="let client of clients" [value]="client.id">
          {{ client.name }}
        </option>
      </select>
      <label for="targetName" class="bmd-label-static">New Name</label>
      <input
        type="text"
        name="targetName"
        formControlName="targetName"
        [(ngModel)]="targetName"
        class="form-control"
      />
    </form>
  </wm-modal-confirm>

  <wm-modal-confirm
    [title]="checkpointTitle"
    moduleId="workflow-checkpoints"
    [showButtonText]="false"
    [enabled]="true"
    [showButton]="false"
    #checkpointList
  >
    <wm-workflow-checkpoint-list
      [checkpoints]="checkpoints"
      (onRestore)="restoreCheckpoint($event)"
      [workflowId]="selectedWorkflowId"
    ></wm-workflow-checkpoint-list>
  </wm-modal-confirm>
</div>
